export default __webpack_public_path__ + "static/media/il.3bc4ce04.svg";